import { searchConstants } from '../_constants/search.constants';

export const searchStart = (keyword) => ({
  type: searchConstants.FETCH_MAIN_SEARCH_START,
  payload: keyword
});

export const searchSuccess = (data) => ({
  type: searchConstants.FETCH_MAIN_SEARCH_SUCCESS,
  payload: data
});

export const searchFailure = (errorMessage) => ({
  type: searchConstants.FETCH_MAIN_SEARCH_FAILURE,
  payload: errorMessage
});

export const clearSearch = () => ({
  type: searchConstants.CLEAR_MAIN_SEARCH
});

export const updateSearch = (searchText) => ({
  type: searchConstants.UPDATE_MAIN_SEARCH,
  payload: searchText
});

export const removeSearch = () => ({
  type: searchConstants.REMOVE_MAIN_SEARCH
});

// Search Fund Ranking
export const subNavSearchStart = (keyword) => ({
  type: searchConstants.FETCH_SUBNAV_SEARCH_START,
  payload: keyword
});

export const subNavSearchSuccess = (data) => ({
  type: searchConstants.FETCH_SUBNAV_SEARCH_SUCCESS,
  payload: data
});

export const subNavSearchFailure = (errorMessage) => ({
  type: searchConstants.FETCH_SUBNAV_SEARCH_FAILURE,
  payload: errorMessage
});

export const clearSubNavSearch = () => ({
  type: searchConstants.CLEAR_SUBNAV_SEARCH
});

export const updateSubNavSearch = (searchText) => ({
  type: searchConstants.UPDATE_SUBNAV_SEARCH,
  payload: searchText
});

export const removeSubNavSearch = () => ({
  type: searchConstants.REMOVE_SUBNAV_SEARCH
});

// Search Fund Calendar
export const searchFundCalendarStart = (keyword) => ({
  type: searchConstants.FETCH_SEARCH_FUND_CALENDAR_START,
  payload: keyword
});

export const searchFundCalendarSuccess = (data) => ({
  type: searchConstants.FETCH_SEARCH_FUND_CALENDAR_SUCCESS,
  payload: data
});

export const searchFundCalendarFailure = (errorMessage) => ({
  type: searchConstants.FETCH_SEARCH_FUND_CALENDAR_FAILURE,
  payload: errorMessage
});

export const clearSearchFundCalendar = () => ({
  type: searchConstants.CLEAR_SEARCH_FUND_CALENDAR
});

export const updateSearchFundCalendar = (searchText) => ({
  type: searchConstants.UPDATE_SEARCH_FUND_CALENDAR,
  payload: searchText
});

export const removeSearchFundCalendar = () => ({
  type: searchConstants.REMOVE_SEARCH_FUND_CALENDAR
});
